import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchLegal } from "../lib/api";
import LegalDoc from "../components/LegalDoc";

/** Public. The whole agreement, readable before anyone signs in. */
export default function Legal() {
  const [d, setD] = useState(null);
  const [tab, setTab] = useState("terms");

  useEffect(() => {
    const want = window.location.hash?.replace("#", "");
    if (want) setTab(want);
    fetchLegal().then(setD).catch(() => setD(null));
  }, []);

  const doc = d?.documents?.find((x) => x.id === tab) || d?.documents?.[0];

  return (
    <div
      data-testid="legal-page"
      className="grain thin-scroll h-full overflow-y-auto bg-[var(--void)]"
    >
      <div className="mx-auto max-w-3xl px-7 py-16 sm:px-12">
        <Link to="/" className="label hover:text-zinc-200">
          ← Covalence / Sphere
        </Link>
        <h1 className="mt-7 font-display text-4xl leading-[1.0] tracking-tight sm:text-5xl">
          The agreement,
          <br />
          <span className="italic text-zinc-400">in full.</span>
        </h1>

        {!d && <p className="label mt-10">Loading the documents…</p>}

        {d && (
          <>
            <p className="mt-7 max-w-xl text-sm leading-relaxed text-zinc-400">
              Three documents, accepted together before the first question: the terms you are held
              to, what happens to your answers, and the risks of sitting for this. Bundle v
              {d.bundle_version}, between you and {d.entity}, governed by the law of{" "}
              {d.jurisdiction}.
            </p>

            <div className="mt-10 flex flex-wrap gap-px border-y border-[var(--line)]">
              {d.documents.map((x) => (
                <button
                  key={x.id}
                  data-testid={`legal-tab-${x.id}`}
                  onClick={() => setTab(x.id)}
                  className={`px-4 py-3 font-data text-[10px] uppercase tracking-[0.16em] transition-colors ${
                    doc?.id === x.id
                      ? "bg-zinc-100 text-[var(--void)]"
                      : "text-zinc-500 hover:text-zinc-200"
                  }`}
                >
                  {x.title}
                </button>
              ))}
            </div>

            <div className="mt-12">{doc && <LegalDoc doc={doc} />}</div>

            <div className="mt-16 border-t border-[var(--line)] pt-8">
              <p className="font-data text-[10px] leading-relaxed text-zinc-600">
                bundle fingerprint {d.bundle_hash?.slice(0, 40)}…
                <br />
                questions, notices and deletion requests · {d.contact}
              </p>
              <Link
                to="/privacy"
                data-testid="legal-privacy-link"
                className="label mt-6 inline-block underline decoration-[var(--line-hi)] underline-offset-4 hover:text-zinc-200"
              >
                The operational privacy statement, generated from the running code →
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
